import PropTypes from 'prop-types';
import clsx from 'clsx';

const defaultProps = {
  htmlId: null,
  error: null,
  touched: false,
  hasError: false,
  light: true,
  onChange: () => null,
};

const propTypes = {
  htmlId: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
      display: PropTypes.node.isRequired,
      useHtml: PropTypes.bool,
    }).isRequired,
  ),
  error: PropTypes.string,
  touched: PropTypes.bool,
  hasError: PropTypes.bool,
  light: PropTypes.bool,
  onChange: PropTypes.func,
};

export default function SelectBoxControl({
  htmlId,
  className,
  disabled,
  error,
  touched,
  hasError,
  light,
  options,
  onChange,
  ...rest
}) {
  const hasErrorFinal = hasError || (error !== null && touched === true);

  let finalClasses = ['border rounded-md focus:ring-2 focus:border-transparent focus:bg-white block w-full text-base h-10 px-3 focus:outline-none font-medium placeholder-gray-400'];

  if (light) {
    finalClasses = [
      ...finalClasses,
      'border-transparent',
      hasErrorFinal === false && 'bg-gray-100 focus:ring-green-200',
      hasErrorFinal === true && 'bg-red-50 focus:ring-red-200',
    ];
  } else {
    finalClasses = [
      ...finalClasses,
      'bg-white',
      'shadow-sm',
      hasErrorFinal === false && 'border-gray-400 bg-white focus:ring-green-500',
      hasErrorFinal === true && 'border-red-400 bg-red-50 focus:border-transparent focus:ring-red-500',
    ];
  }

  return (
    <div className="relative">
      <select
        id={htmlId}
        className={clsx(
          finalClasses,
          disabled === true && 'pointer-events-none opacity-70',
          className,
        )}
        onChange={(e) => onChange(e.target.value)}
        {...rest}
      >
        {options.map(({ value, display, useHtml }) => {
          if (useHtml === true) {
            return (
              <option
                key={value}
                value={value}
                dangerouslySetInnerHTML={{ __html: display }}
              />
            );
          }

          return (
            <option key={value} value={value}>
              {display}
            </option>
          );
        })}
      </select>
    </div>
  );
}

SelectBoxControl.defaultProps = defaultProps;
SelectBoxControl.propTypes = propTypes;
